import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { TailSpin } from "react-loader-spinner";
import "./StickySaveBar.css";

type Props = {
  onSave: () => void;
  saving: boolean;
  dirty?: boolean;
  onCancel?: () => void;
  saveLabel?: string;
  savingLabel?: string;
};

export default function StickySaveBar({
  onSave,
  saving,
  dirty,
  onCancel,
  saveLabel = "Salva",
  savingLabel = "Salvataggio…",
}: Props) {
  return (
    <div className="sticky-save-bar" role="region" aria-label={saveLabel}>
      {onCancel && (
        <button
          type="button"
          className="sticky-save-bar-cancel"
          onClick={onCancel}
          disabled={saving}
        >
          Annulla
        </button>
      )}
      {dirty && (
        <span className="sticky-save-bar-status" aria-live="polite">
          <span className="sticky-save-bar-dot" />
          Modifiche non salvate
        </span>
      )}
      <button
        type="button"
        className="sticky-save-bar-save"
        onClick={onSave}
        disabled={saving}
        aria-busy={saving}
      >
        {saving ? (
          <>
            <TailSpin width={18} height={18} color="#fff" />
            <span className="sticky-save-bar-save-label">{savingLabel}</span>
          </>
        ) : (
          <>
            <FontAwesomeIcon icon={faSave} />
            <span className="sticky-save-bar-save-label">{saveLabel}</span>
          </>
        )}
      </button>
    </div>
  );
}
